const prefix = "LOOKUP_";

export const LOAD_STATIC_LOOKUPS_STARTED = prefix + "LOAD_STATIC_LOOKUPS_STARTED";
export const LOAD_STATIC_LOOKUPS_SUCCEEDED = prefix + "LOAD_STATIC_LOOKUPS_SUCCEEDED";
export const LOAD_STATIC_LOOKUPS_FAILED = prefix + "LOAD_STATIC_LOOKUPS_FAILED";
export const LOAD_DYNAMIC_LOOKUPS_STARTED = prefix + "LOAD_DYNAMIC_LOOKUPS_STARTED";
export const LOAD_DYNAMIC_LOOKUPS_SUCCEEDED = prefix + "LOAD_DYNAMIC_LOOKUPS_SUCCEEDED";
export const LOAD_DYNAMIC_LOOKUPS_FAILED = prefix + "LOAD_DYNAMIC_LOOKUPS_FAILED";
